<template>
  <div class="phenotype-disease-path-detail-page col-block width-full">
    <div class="text" :class="{ nodes: paths.length }" v-html="textData.text"></div>
    <template v-if="paths.length">
      <div :style="{ height: '5px' }"></div>
      <div class="node-container col-block">
        <div class="dash-line"></div>
        <div class="node-block row-block stretch" v-for="(path, index) in paths" :key="index">
          <div class="point-container">
            <div class="point"></div>
          </div>
          <div><div :style="{ width: '5px' }"></div></div>
          <div class="node-title" >{{ path.name }}</div>
          <div><div :style="{ width: '5px' }"></div></div>
          <div class="link-container">
            <a class="link" :href="'https://hpo.jax.org/app/browse/term/' + path.id" target="_blank">
              <img :src="require('../../assets/icons/external-link-icon.svg')" alt="">
            </a>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    paths: {
      type: Array,
      required: true
    }
  },
  computed: {
    textData () {
      return this.paths ? {
        text: {
          '0': this.$t('COMPONENT.phenotypeDisease.pathDetail.text.___text01'),
          '1': this.$t('COMPONENT.phenotypeDisease.pathDetail.text.___text02')
        }[this.paths.length + ''] || this.$t('COMPONENT.phenotypeDisease.pathDetail.text.___text03', { length: this.paths.length - 1 })
      } : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/phenotypeDisease/pathDetail.vue